<template>
  <section class="detail">
    <template v-if="!state.loading">
      <div class="columns is-multiline">
        <div class="column">
          <b-image responsive :src="instance.picture" alt="Placeholder image" />
        </div>
        <div class="column">
          <h1 class="title">{{ instance.fullName }}</h1>
          <h2 class="subtitle">{{ instance.nicknames }}</h2>
          <ul>
            <li>{{ instance.estado }}</li>
            <template v-if="instance.personalData">
              <li v-if="instance.personalData.fechanac">
                Fecha de nacimiento:
                {{ instance.personalData.fechanac }}
              </li>
              <li v-if="instance.personalData.estcivil">
                {{ instance.personalData.estcivil }}
              </li>
              <li v-if="instance.personalData.prof">
                {{ instance.personalData.prof }}
              </li>
            </template>
          </ul>
        </div>
      </div>
      <div class="columns is-multiline">
        <div class="column">
          <div class="content detail">
            <p>{{ instance.description }}</p>
          </div>
        </div>
      </div>
      <detail-paginator />
    </template>
    <template v-else>
      <div class="columns is-multiline">
          <div class="column">
            <figure class="image">
              <b-skeleton width="320px" height="245px"></b-skeleton>
            </figure>          
          </div>
          <div class="column">
            <h1 class="title"><b-skeleton size="is-medium"/></h1>
            <h2 class="subtitle"><b-skeleton /></h2>
            <ul>
              <li><b-skeleton /></li>

              <li>
                <b-skeleton />
              </li>
              <li>
                <b-skeleton />
              </li>
            </ul>
          </div>
        </div>
        <div class="columns is-multiline">
          <div class="column">
            <div class="content detail">
              <b-skeleton height="180px"></b-skeleton>
            </div>
          </div>
        </div>
    </template>

  </section>
</template>
<script>
import store from "@/store";
import { Condenado } from "@/models.js";
import DetailPaginator from "@/components/DetailPaginator.vue";

export default {
  components: { DetailPaginator },
  created() {
    this.fetchData();
  },
  watch: {
    // call again the method if the route changes
    $route: "fetchData",
  },
  methods: {
    fetchData() {
      const idcaso = this.$route.params.id;
      const query = Object.assign(this.state.query, this.$route.query);
      this.state.query = query;
      if (typeof idcaso !== "undefined") {
        Condenado.fetch(idcaso, query);
      }
    },
  },
  computed: {
    instance() {
      return this.state.activeInstance;
    },
  },
  title() {
    if (this.state.activeInstance) {
      return this.state.activeInstance.fullname;
    }
  },
  data() {
    return {
      state: store.state,
    };
  },
};
</script>